import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const ProfessionalsListStyled = styled.div`
  width: 100%;
  max-height: 210px;
  overflow-y: auto;
  position: absolute;
  top: 73px;
  display: grid;
  gap: 4px;
  grid-auto-rows: max-content;
  padding: 12px 8px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.grey300};
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 10px 45px 0px rgba(14, 40, 83, 0.07);
  z-index: 10;
`;

export const ProfessionalItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.color.grey100};
  }
`;

export const IconStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.blueDark100};
  color: ${({ theme }) => theme.color.grey900};
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
`;

export const InfStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;

  h2 {
    color: ${({ theme }) => theme.color.grey900};
    font-size: 14px;
    font-weight: 700;
    line-height: 19.6px;
  }

  p {
    color: ${({ theme }) => theme.color.grey600};
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
  }
`;
